import { AvailabilityBlockCard as AvailabilityBlockCardPure } from './AvailabilityBlockCard';
import { connectAvailabilityBlockCard } from './connectAvailabilityBlockCard';

export const AvailabilityBlockCard = connectAvailabilityBlockCard(AvailabilityBlockCardPure);
